export const environment = {
  production: true,
  version: '0.0.635.20261103201012',
  firebase: {
    apiKey: "AIzaSyBHbthwTgTX192d028-vrmesP2T09v2yUM",
    authDomain: "events.picaggo.com",
    //authDomain: "picaggo-235807.firebaseapp.com",
    databaseURL: "https://picaggo-235807.firebaseio.com",
    projectId: "picaggo-235807",
    storageBucket: "picaggo-235807.appspot.com",
    messagingSenderId: "896982317636",
    appId: "1:896982317636:web:f903d4ad1cc4dbc5c51a11",
    measurementId: "G-6KS7CT2F09"
  },
  aws: {
    
   IdentityPoolId: 'us-west-1:2e468d80-204f-4b20-a1d9-3533e78c70a4',

    accessKeyId: "",
    secretAccessKey: "",
    region: "us-west-1",
    bucketName: "picaggo-app",
    userBucket: "picaggo-users",
    testBucket: "test-picaggo",
    logBucket: "picaggo-app", // where pwa_logs/ goes; keep out of the pwa/ prefix so the media trigger ignores it
    uploadFolder: "pwa"
  },
    uploadProgressApi: "https://gtt38vh7y4.execute-api.us-west-1.amazonaws.com/default/file-upload-progress",
  canvaTemplatesUrl: 'https://xwx8zqxv2l.execute-api.us-west-1.amazonaws.com/default/pwa-canva-integration?action=templates',
  canvaApiUrl: 'https://xwx8zqxv2l.execute-api.us-west-1.amazonaws.com/default/pwa-canva-integration',
  canvaFolderId: 'FAF-c12QwZU',
  posthogKey: 'phc_oyAP3mUi4imiYFhAUDmK74okna8Su9v4N5Dho43m6yC2',
  // See environment.ts.
  adsConversionTrackingUrl: 'https://udra6fsqt6.execute-api.us-west-1.amazonaws.com/default/ads-conversion-tracking',
  // See environment.ts.
  inviteLinkBase: 'https://i.picaggo.com/',
  // Off in production until these are ready to ship. See environment.ts.
  features: {
    whatsappUpload: true,
    // See environment.ts. Off until tested end to end with a real Twilio
    // sandbox/number.
    whatsappInviteLink: true,
    themeSwitcher: false,
    // See environment.ts. Shipped.
    flipbook: true,
    // See environment.ts.
    flipbookSharing: true,
    // See environment.ts. Deliberately off: this is a test-deploy experiment to
    // find out whether the minimize-and-navigate path gets used at all. The
    // `upload_minimized` event still fires in prod, so the data comes in either
    // way — flip this to true once it justifies the surface.
    persistentUploadBanner: true,
    // See environment.ts. Off until the `markFailed` action is deployed to the
    // file-upload-progress Lambda; flip it to true once that is live.
    reportFailedUploads: true,
    // See environment.ts. Off until the deferred-login front door has been
    // tested end to end — this one changes where every sessionless visitor
    // lands, so it is the last of these to flip.
    deferredLogin: true,
    // See environment.ts. Off until the card designer dialog and the Canva
    // template links have been clicked through for real.
    cardDesigner: false,
    // See environment.ts. These are existing, already-shipped surfaces — on by
    // default in prod, unlike the test flags above. Kill switches only.
    publicEvent: false,
    eventBranding: true,
    watermarking: true,
    // See environment.ts. Off until Manage Event has been tested — hides the
    // "Manage Event" menu item and the Sorting Order / Guest Uploads sections
    // it added to the classic Event Settings page.
    manageEventHub: true,
    // See environment.ts. Off until the new invite design has been used for
    // real — the old share screen renders exactly as before until this flips.
    newInviteDesign: true,
    // See environment.ts. Off until the server keeps a view-only link view-only.
    viewerInviteLink: false,
    // See environment.ts. On for every host from the 2026-11 release: the
    // minimal Create Event (BUILD_PLAN_INVITE_AB_AND_CREATE_2026-11-03.md,
    // Part 1), shipped with the invite A/B test on both arms. Runtime kill
    // switch: PostHog flag `create-event-rows-off` brings back the chip form.
    createEventRows: true,
    // See environment.ts. Off until voice has been tested on Android, iOS and
    // desktop. Needs createEventRows.
    voiceCreate: false,
    // See environment.ts.
    featureSettings: false,
    // See environment.ts. On in prod since 2026-10-28: guests open the album
    // with one tap and are asked their name at their first upload.
    quickGuestJoin: true
  },
  // See environment.ts.
  voiceCreate: {
    maxSeconds: 30,
    // See environment.ts. Off until the conversation has been tried on the sandbox.
    chat: false,
    remoteKillSwitchFlag: 'voice-create-off',
    remoteParseUrl: '',
    // See environment.ts. Empty until pwa-transcribe-voice is deployed and tested.
    transcribeUrl: '',
  },
  // See environment.ts.
  adminApi: {
    updateUrl: '',
  },
  // See environment.ts. Both URLs empty until the backend endpoints exist —
  // link sharing stays off and the viewer keeps the send-a-clip path.
  flipbookShare: {
    createUrl: 'https://qd6rt2e177.execute-api.us-west-1.amazonaws.com/default/pwa-save-flipbook-data',
    readUrl: 'https://xl5jav3640.execute-api.us-west-1.amazonaws.com/default/pwa-get-flipbook-data',
    expiryDays: 90,
  },
  // The invite card as the link preview. The share screen uploads the square
  // card the host picked to picaggo-app (events/{id}/invite/card-{ms}.jpg) and
  // records it through this endpoint, which generate-preview-url then serves as
  // og:image. The same endpoint saves a cover changed from the share screen.
  // Empty = off: no upload, no save, and the card's edit-cover button hides.
  // Endpoint: Picaggo_Lambdas/pwa-save-invite-card (run its migration.sql first).
  inviteCard: {
    saveUrl: 'https://9fi8wtzxji.execute-api.us-west-1.amazonaws.com/default/pwa-save-invite-card',
  },
  // See environment.ts. Set `minUserId` to MAX(user_tbl.id) when deploying.
  // Never allow the ?invite= override here: it would let anyone pick a version.
  inviteAb: {
    enabled: true,
    minUserId: 11855,
    remoteKillSwitchFlag: 'invite-ab-off',
    allowOverride: false,
  },
  // See environment.ts. Flip `enabled` to false (and redeploy) or turn on the
  // PostHog kill-switch flag (no redeploy) to take the wall down in production.
  guestPhotoWall: {
    enabled: true,
    photoThreshold: 50,
    // A PostHog feature flag that force-disables the wall at runtime, with no
    // redeploy. Deliberately named as a kill switch rather than an enable
    // switch: only an explicitly ON flag turns the wall off, so a missing flag,
    // unloaded flags or a PostHog blocked by an ad blocker all leave the
    // `enabled` value above in charge. Set to '' to skip the check entirely.
    remoteKillSwitchFlag: 'guest-photo-wall-off'
  },
  // See environment.ts. Off in production until it has been tried on the
  // sandbox; flip `enabled` to true to ship it.
  guestHostPrompt: {
    enabled: false,
    browseAfterPhotos: 100,
    minGalleryPhotos: 30,
    remoteKillSwitchFlag: 'guest-host-prompt-off'
  }
};
